import $x from '@/utils/$x';

/**
 * 拉群规则配置-首页
 * @param {*} params
 * @returns
 */
export async function getGroupRuleList(params) {
  return $x.post('/wx/pull/group/rule/list', params);
}

/**
 * 拉群规则配置-新增
 * @param {*} params
 * @returns
 */
export async function addGroupRule(params) {
  return $x.post('/wx/pull/group/rule/add', params);
}

/**
 * 拉群规则配置-修改
 * @param {*} params
 * @returns
 */
export async function updateGroupRule(params) {
  return $x.post('/wx/pull/group/rule/update', params);
}

/**
 * 拉群规则配置-删除
 * @param {*} params
 * @returns
 */
export async function deleteGroupRule(params) {
  return $x.post('/wx/pull/group/rule/delete', params);
}

/**
 * 拉群规则配置-查询
 * @param {*} params
 * @returns
 */
export async function getGroupRule(params) {
  return $x.post('/wx/pull/group/rule/get', params);
}
